export const NO_STATE_SELECTION = 'State'
